import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import { BasePage } from './component';
import { selectType } from '../../../ReduxStorage/location/selectors';

function mapStateToProps(state) {
  return {
    type: selectType(state),
  };
}

export const ConnectedBasePage = hot(connect(mapStateToProps)(BasePage));
